import JoinRoomSlice from "./feature/join-room/JoinRoomSlice";
import AiAssistantSlice from "./feature/ai-assistant/AiAssistantSlice";
import { configureStore } from "@reduxjs/toolkit";

/**
 *@summary Redux Toolkit store configuration with support for adding multiple reducers
 */
export const store = configureStore({
  /**
   *@description reducer:{[reducerName]:[Slice]}
   */
  reducer: { joinRoom: JoinRoomSlice, aiAssistant: AiAssistantSlice },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
